/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { updateExitModalStatus } from '../../../../actions/signingRoomActions';
import { SigningRoomNavigationItem } from '../SigningRoomNavigationItem';
import { SigningRoomNavigationItemData, SigningRoomNavigationItemIds } from '../signingRoomItems';

export namespace SigningRoomNavigationExitItem {
  export interface Props {}
}

export const navigationExitItem: Omit<SigningRoomNavigationItemData, 'contentComponent'> = {
  id: SigningRoomNavigationItemIds.exit,
  title: 'Exit',
};

export const SigningRoomNavigationExitItem: React.FC<SigningRoomNavigationExitItem.Props> = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    updateExitModalStatus(true)(dispatch);
  };

  return <SigningRoomNavigationItem id={navigationExitItem.id} title={navigationExitItem.title} onClick={onClick} />;
};
